import { t } from 'i18next'
import { RouteObject } from "react-router-dom";
import { MenuItem } from 'primereact/menuitem'
import { lazy } from 'react';

const OrderTrackingPage  = lazy( () => import('../containers/OrderTracking/OrderTrackingContainer') );
const OrderTrackingDocumentPage = lazy( () => import('../containers/OrderTracking/OrderTrackingDocumentContainer') );

export const ORDER_TRACKING_PATHS = {
    HOME: '/order-tracking',
    CONFIRM_ORDER_PDF: (orderNumber?: number) => `/order-tracking/get-document/${orderNumber ? orderNumber : ':orderNumber'}`
} as const

export const orderTrackingRoutes: RouteObject[] = [
    {
        path: ORDER_TRACKING_PATHS.HOME,
        children: [
            {
                index: true,
                element: <OrderTrackingPage />,
                handle: {
                  crumb: (): MenuItem[] => [
                    { label: t('general:menu.order_tracking') || '', url: ORDER_TRACKING_PATHS.HOME },
                  ],
                },
            },
            
            {
              path: ORDER_TRACKING_PATHS.CONFIRM_ORDER_PDF(),
              element: <OrderTrackingDocumentPage />,
            }
            
        ],
    }
]